//Global imports
import React from 'react';

interface LengthCheckerProps {
    currentLength: number;
    maxLength: number;
    align?: 'left' | 'right' | 'center';
}

const LengthChecker: React.FC<LengthCheckerProps> = ({
    currentLength,
    maxLength,
    align = 'right',
}) => {
    const alignmentClass =
        align === 'left'
            ? 'text-start'
            : align === 'center'
              ? 'text-center'
              : 'text-end';

    const textColorClass =
        currentLength >= maxLength ? 'text-danger' : 'text-secondary';

    return (
        <div className={`small mt-1 ${alignmentClass} ${textColorClass}`}>
            {currentLength}/{maxLength}
        </div>
    );
};

export default LengthChecker;
